export enum LANDING_TYPE {
  HACKER_VIEW = 'digital-footprint-checker',
  BREACH_CHECKER_EVERGREEN = 'breach-checker',
  BREACH_SCAN = 'breach-scan',
  BREACH_CHECKER_NATIONAL_PUBLIC_DATA = 'npd-breach',
  DBOO = 'data-broker-removal',
  SCAM_GAME = 'swipe-the-scam',
  THEFT_RISK_REPORT = 'identity-theft-exposure-scan',
}
